import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TriangleRight } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { Tooltip } from "@air/primitive-tooltip";
import { tailwindVariants } from "@air/tailwind-variants";
import { useControllableState } from "@radix-ui/react-use-controllable-state";
import classNames from "classnames";
import { forwardRef, memo } from "react";
export const treeItem = tailwindVariants({
    base: "group/treeItem relative z-1 flex shrink-0 items-center gap-2 rounded-2 px-2 text-grey-11 outline outline-2 -outline-offset-2 outline-transparent hover:bg-grey-3 [.dragging_&]:opacity-50 [.hovering-drop_&]:bg-grey-3 [.hovering-drop_&]:outline-macaw-300 [.moving-item_&]:opacity-50",
    variants: {
        size: {
            small: "h-8 text-14",
            medium: "h-9 text-16"
        },
        state: {
            active: "bg-grey-4",
            default: "bg-transparent",
            selected: "bg-blue-1 hover:bg-blue-2"
        }
    },
    defaultVariants: {
        size: "medium",
        state: "default"
    }
});
export const TREE_ITEM_ELEMENT_TYPE = "div";
const _TreeItem = /*#__PURE__*/ forwardRef((param, forwardedRef)=>{
    let { children, className, defaultOpen, disabled, onOpenChange, open: openProp, prefix, size, state, suffix, ...restOfProps } = param;
    const [open = false, setOpen] = useControllableState({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    const label = open ? "Collapse" : "Expand";
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": "TREE_ITEM",
        className: treeItem({
            size,
            state,
            class: className
        }),
        ref: forwardedRef,
        ...restOfProps,
        children: [
            /*#__PURE__*/ _jsx(Tooltip, {
                label: label,
                children: /*#__PURE__*/ _jsx(IconButton, {
                    appearance: "ghost",
                    className: "z-1 shrink-0",
                    color: "grey",
                    disabled: disabled,
                    label: label,
                    onClick: ()=>setOpen((prevOpen)=>!prevOpen),
                    size: "extra-small",
                    "data-testid": open ? "TREE_ITEM_COLLAPSE_BUTTON" : "TREE_ITEM_EXPAND_BUTTON",
                    children: /*#__PURE__*/ _jsx(TriangleRight, {
                        className: classNames("h-4 w-4 transition-transform", open ? "rotate-90" : "rotate-0")
                    })
                })
            }),
            prefix && /*#__PURE__*/ _jsx("div", {
                className: "shrink-0",
                children: prefix
            }),
            children,
            suffix && /*#__PURE__*/ _jsx("div", {
                className: "shrink-0",
                children: suffix
            })
        ]
    });
});
_TreeItem.displayName = "_TreeItem";
export const TreeItem = /*#__PURE__*/ memo(_TreeItem);
